import styled from 'styled-components';
import down from './img/caret_down.svg';
import up from './img/caret_up.svg';
var caret_down = 'url(' + down + ');'; // eslint-disable-line

var caret_up = 'url(' + up + ');'; // eslint-disable-line

export var Caret = styled.div.withConfig({
  displayName: "style__Caret",
  componentId: "sc-7jd8sz-0"
})(["height:36px;line-height:36px;width:36px;font-size:20px;text-align:center;display:inline-block;background-position:center;background-repeat:no-repeat;background-image:", ";border:none;background-color:none;background-size:50%;"], function (props) {
  return props.active ? caret_up : caret_down;
});
export var IconContainer = styled.div.withConfig({
  displayName: "style__IconContainer",
  componentId: "sc-7jd8sz-1"
})(["width:", ";height:", ";align-items:center;justify-content:center;margin:auto;"], function (props) {
  return props.width ? props.width : '100%';
}, function (props) {
  return props.height ? props.height : '100%';
});